import request from '@/utils/request'

let OpinionApi = {

  /*意见反馈列表*/
  list(data) {
    return request._post('/shop/plus.opinion.Index/index', data);
},
/*添加意见反馈*/
add(data) {
    return request._post('/shop/plus.opinion.Index/add', data);
},
/*修改意见反馈*/
edit(data) {
    return request._post('/shop/plus.opinion.Index/edit', data);
},
/*删除意见反馈*/
del(data) {
    return request._post('/shop/plus.opinion.Index/del', data);
},
/*意见反馈详情*/
detail(data) { 
  return request._post('/shop/plus.opinion.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.opinion.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.opinion.Setting/getSetting', data, errorback);
    },
}
export default OpinionApi;



// WEBPACK FOOTER //
// ./src/api/opinion.js